webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(95);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(94);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _Home = __webpack_require__(84);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Overview = __webpack_require__(85);
	
	var _Overview2 = _interopRequireDefault(_Overview);
	
	var _PlayerDetails = __webpack_require__(86);
	
	var _PlayerDetails2 = _interopRequireDefault(_PlayerDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	new _vue2.default({
	  router: new _vueRouter2.default({
	    routes: [{ path: '/', component: _Home2.default }, { path: '/overview', component: _Overview2.default }, { path: '/player/:index', component: _PlayerDetails2.default }]
	  })
	}).$mount('#app');

/***/ },

/***/ 33:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(13);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _SetupPlayer = __webpack_require__(88);
	
	var _SetupPlayer2 = _interopRequireDefault(_SetupPlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'home',
	  components: {
	    SetupPlayer: _SetupPlayer2.default
	  },
	  data: function data() {
	    var players = JSON.parse(window.localStorage.getItem('players'));
	    if (!players) players = [{ name: 'Player 1' }, { name: 'Player 2' }];
	    players.forEach(function (p) {
	      p.rounds = [{}];
	    });
	    return {
	      players: players
	    };
	  },
	
	  computed: {
	    canStart: function canStart() {
	      return this.players.filter(function (p) {
	        return p.name;
	      }).length >= 2;
	    }
	  },
	  methods: {
	    addPlayer: function addPlayer() {
	      this.players.push({ name: '', rounds: [{}] });
	    },
	    start: function start() {
	      window.localStorage.setItem('players', (0, _stringify2.default)(this.players.filter(function (p) {
	        return p.name;
	      })));
	      this.$router.push('overview');
	    }
	  }
	};

/***/ },

/***/ 34:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(39);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(13);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _isInteger = __webpack_require__(19);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _Player = __webpack_require__(87);
	
	var _Player2 = _interopRequireDefault(_Player);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'overview',
	  components: {
	    Player: _Player2.default
	  },
	  data: function data() {
	    return {
	      players: []
	    };
	  },
	  created: function created() {
	    this.players = JSON.parse(window.localStorage.getItem('players'));
	    if (!this.players) {
	      return this.$router.replace('./');
	    }
	
	    if (this.needsNewRound()) {
	      this.addNewRound();
	    }
	  },
	
	  computed: {
	    round: function round() {
	      return this.players[0].rounds.length;
	    }
	  },
	  methods: {
	    needsNewRound: function needsNewRound() {
	      return this.players.filter(function (p) {
	        var lastRound = p.rounds[p.rounds.length - 1];
	        return !(0, _isInteger2.default)(lastRound.blitz) || !(0, _isInteger2.default)(lastRound.dutch);
	      }).length === 0;
	    },
	    addNewRound: function addNewRound() {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.players), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var p = _step.value;
	
	          p.rounds.push({});
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      window.localStorage.setItem('players', (0, _stringify2.default)(this.players));
	    }
	  }
	};

/***/ },

/***/ 35:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parseInt = __webpack_require__(40);
	
	var _parseInt2 = _interopRequireDefault(_parseInt);
	
	var _stringify = __webpack_require__(13);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'playerDetails',
	  data: function data() {
	    return {
	      players: [],
	      total: 0
	    };
	  },
	  created: function created() {
	    this.players = JSON.parse(window.localStorage.getItem('players'));
	    if (!this.players) {
	      return this.$router.replace('../');
	    }
	    this.updateTotal();
	  },
	
	  computed: {
	    player: function player() {
	      return this.players[this.$route.params.index] || {};
	    }
	  },
	  methods: {
	    save: function save() {
	      window.localStorage.setItem('players', (0, _stringify2.default)(this.players));
	      this.updateTotal();
	    },
	    updateTotal: function updateTotal() {
	      this.total = this.player.rounds.reduce(function (acc, round) {
	        return acc + (round.blitz || 0) * -2 + (round.dutch || 0);
	      }, 0) || 0;
	    },
	    next: function next() {
	      this.$router.replace('' + ((0, _parseInt2.default)(this.$route.params.index, 10) + 1) % this.players.length);
	    }
	  },
	  filters: {
	    minusBlitz: function minusBlitz(round) {
	      var n = round.blitz * -2;
	      return isNaN(n) ? '' : n;
	    },
	    roundTotal: function roundTotal(round) {
	      var total = round.blitz * -2 + round.dutch;
	      return isNaN(total) ? '' : total;
	    }
	  }
	};

/***/ },

/***/ 36:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isInteger = __webpack_require__(19);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _toConsumableArray2 = __webpack_require__(41);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'player',
	  props: ['player', 'index', 'players'],
	  computed: {
	    total: function total() {
	      return this.getTotal(this.player);
	    },
	    isHighest: function isHighest() {
	      return this.total > 0 && this.total === Math.max.apply(Math, (0, _toConsumableArray3.default)(this.players.map(this.getTotal)));
	    },
	    lastBlitz: function lastBlitz() {
	      return this.player.rounds[this.player.rounds.length - 1].blitz;
	    },
	    lastDutch: function lastDutch() {
	      return this.player.rounds[this.player.rounds.length - 1].dutch;
	    },
	    isBlitzInvisible: function isBlitzInvisible() {
	      return !(0, _isInteger2.default)(this.lastBlitz);
	    },
	    isDutchInvisible: function isDutchInvisible() {
	      return !(0, _isInteger2.default)(this.lastDutch);
	    }
	  },
	  methods: {
	    details: function details() {
	      this.$router.push('player/' + this.index);
	    },
	    getTotal: function getTotal(player) {
	      return player.rounds.reduce(function (acc, round) {
	        return acc + (round.blitz || 0) * -2 + (round.dutch || 0);
	      }, 0) || 0;
	    }
	  }
	};

/***/ },

/***/ 37:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'setupPlayer',
	  props: ['player']
	};

/***/ },

/***/ 79:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 80:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 81:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 82:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 83:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 84:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(79)
	__webpack_require__(80)
	
	/* script */
	__vue_exports__ = __webpack_require__(33)
	
	/* template */
	var __vue_template__ = __webpack_require__(89)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0489c196"
	
	module.exports = __vue_exports__


/***/ },

/***/ 85:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(34)
	
	/* template */
	var __vue_template__ = __webpack_require__(91)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 86:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(83)
	
	/* script */
	__vue_exports__ = __webpack_require__(35)
	
	/* template */
	var __vue_template__ = __webpack_require__(93)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-729e9b7a"
	
	module.exports = __vue_exports__


/***/ },

/***/ 87:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(81)
	
	/* script */
	__vue_exports__ = __webpack_require__(36)
	
	/* template */
	var __vue_template__ = __webpack_require__(90)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-48f05e93"
	
	module.exports = __vue_exports__


/***/ },

/***/ 88:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(82)
	
	/* script */
	__vue_exports__ = __webpack_require__(37)
	
	/* template */
	var __vue_template__ = __webpack_require__(92)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-53eb4c08"
	
	module.exports = __vue_exports__


/***/ },

/***/ 89:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', [_vm._m(0), _vm._v(" "), _c('main', [_vm._l((_vm.players), function(player, index) {
	    return _c("setup-player", {
	      tag: "div",
	      attrs: {
	        "player": player
	      },
	      on: {
	        "removePlayer": function($event) {
	          _vm.players.splice(index, 1)
	        }
	      }
	    })
	  }), _vm._v(" "), _c('button', {
	    staticClass: "add",
	    on: {
	      "click": _vm.addPlayer
	    }
	  }, [_vm._v("Add a player")]), _vm._v(" "), _c('button', {
	    staticClass: "start",
	    attrs: {
	      "disabled": !_vm.canStart
	    },
	    on: {
	      "click": _vm.start
	    }
	  }, [_vm._v("Start")])], true)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('header', [_c('span', [_vm._v("Dutch Blitz Scorekeeper")])])
	}]}

/***/ },

/***/ 90:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "player",
	    on: {
	      "click": _vm.details
	    }
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v(_vm._s(_vm.player.name))]), _vm._v(" "), _c('div', {
	    staticClass: "total",
	    class: {
	      highest: _vm.isHighest
	    }
	  }, [_vm._v(_vm._s(_vm.total))]), _vm._v(" "), _c('div', {
	    staticClass: "status"
	  }, [_c('span', {
	    class: {
	      invisible: _vm.isBlitzInvisible
	    }
	  }, [_vm._v("Blitz: " + _vm._s(_vm.lastBlitz))]), _vm._v(" "), _c('span', {
	    class: {
	      invisible: _vm.isDutchInvisible
	    }
	  }, [_vm._v("Dutch: " + _vm._s(_vm.lastDutch))])])])
	},staticRenderFns: []}

/***/ },

/***/ 91:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', [_c('header', [_c('router-link', {
	    attrs: {
	      "to": "./"
	    }
	  }, [_vm._v("‹ quit")]), _vm._v(" "), _c('span', [_vm._v("Round " + _vm._s(_vm.round))]), _c('span')]), _vm._v(" "), _c('main', _vm._l((_vm.players), function(player, index) {
	    return _c('player', {
	      attrs: {
	        "player": player,
	        "index": index,
	        "players": _vm.players
	      }
	    })
	  }))])
	},staticRenderFns: []}

/***/ },

/***/ 92:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.player.name),
	      expression: "player.name"
	    }],
	    domProps: {
	      "value": _vm._s(_vm.player.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.player.name = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    on: {
	      "click": function($event) {
	        _vm.$emit('removePlayer')
	      }
	    }
	  }, [_vm._v("Remove")])])
	},staticRenderFns: []}

/***/ },

/***/ 93:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', [_c('header', [_c('router-link', {
	    attrs: {
	      "to": "../overview"
	    }
	  }, [_vm._v("‹ overview")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.player.name))]), _c('a', {
	    on: {
	      "click": _vm.next
	    }
	  }, [_vm._v("next ›")])]), _vm._v(" "), _c('main', [_c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.player.rounds), function(round) {
	    return _c('tr', [_c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (round.blitz),
	        expression: "round.blitz"
	      }],
	      attrs: {
	        "type": "number"
	      },
	      domProps: {
	        "value": _vm._s(round.blitz)
	      },
	      on: {
	        "input": [function($event) {
	          if ($event.target.composing) { return; }
	          round.blitz = _vm._n($event.target.value)
	        }, _vm.save],
	        "blur": function($event) {
	          _vm.$forceUpdate()
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("minusBlitz")(round)))]), _vm._v(" "), _c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (round.dutch),
	        expression: "round.dutch"
	      }],
	      attrs: {
	        "type": "number"
	      },
	      domProps: {
	        "value": _vm._s(round.dutch)
	      },
	      on: {
	        "input": [function($event) {
	          if ($event.target.composing) { return; }
	          round.dutch = _vm._n($event.target.value)
	        }, _vm.save],
	        "blur": function($event) {
	          _vm.$forceUpdate()
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("roundTotal")(round)))])])
	  }), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total))])])], true)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('tr', [_c('th', [_vm._v("Blitz")]), _c('th', [_vm._v("* -2")]), _c('th', [_vm._v("Dutch")]), _c('th', [_vm._v("Total")])])
	}]}

/***/ }

});


// WEBPACK FOOTER //
// static/js/app.5704b4f65b28df79b8ef.js